import React, { useState, useEffect } from "react";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../services/firebase";
import { useBuyer } from "../../contexts/BuyerContext";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import "./OpenMarketFinal.css";

const OpenMarketFinal = () => {
  const { buyer } = useBuyer();
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRequests = async () => {
      if (!buyer?.buyerId) {
        setLoading(false);
        return;
      }

      try {
        const q = query(
          collection(db, "openMarketRequests"),
          where("buyerId", "==", buyer.buyerId)
        );
        const snapshot = await getDocs(q);
        const data = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setRequests(data);
      } catch (error) {
        console.error("Error fetching open market requests:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchRequests();
  }, [buyer?.buyerId]);

  const getStatusColor = (status) => {
    switch (status) {
      case "Requested":
        return "yellow";
      case "Finalized":
        return "green";
      case "Completed":
        return "blue";
      default:
        return "gray";
    }
  };

  if (loading) {
    return (
      <div className="open-market-final-container">
        <Header title="Open Market Final" />
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div className="open-market-final-container">
      <Header title="Open Market Final" />
      <div className="requests-list">
        {requests.length === 0 ? (
          <p className="empty-state">No open market requests found.</p>
        ) : (
          requests.map((request) => (
            <div key={request.id} className="request-card">
              <div className="request-header">
                <span className="request-id">{request.requestId}</span>
                <span className={`status-badge status-${getStatusColor(request.status)}`}>
                  {request.status}
                </span>
              </div>
              <div className="request-details">
                <p><strong>Product:</strong> {request.productName}</p>
                <p><strong>Category:</strong> {request.category}</p>
                <p><strong>Specification:</strong> {request.specification}</p>
                <p><strong>Urgency:</strong> {request.urgency}</p>
                <p><strong>Deadline:</strong> {request.deadline}</p>
              </div>
            </div>
          ))
        )}
      </div>
      <Footer />
    </div>
  );
};

export default OpenMarketFinal;
